export default __webpack_public_path__ + "static/media/Irrigation.f19f2e6e.webp";